import type { Distance, SpatialRectangle } from "@pdfking/math"
import type { BasePlotObject } from "./BasePlotObject"
import type { PlotFunction } from "./PlotFunction"

// Specific type for plot_media
export type PlotMedia = {
  crop_position: SpatialRectangle<Distance>
  enum: PlotFunction.PLOT_MEDIA
  media_position: SpatialRectangle<Distance>
  page: string
} & BasePlotObject
